const accessibility = require('./accessibility');
const account = require('./account');
const atc = require('./atc');
const cart = require('./cart');
const chat = require('./chat');
const checkout = require('./checkout');
const contact = require('./contact');
const dispatcher = require('./dispatcher');
const faqs = require('./faqs');
const landing = require('./landing');
const login = require('./login');
const menu = require('./menu');
const modal = require('./modal');
const newsletter = require('./newsletter');
const page = require('./page');
const pageDesigner = require('./pageDesigner');
const pdp = require('./pdp');
const plp = require('./plp');
const productCustomizer = require('./productCustomizer');
const productTile = require('./productTile');
const search = require('./search');
const stockAlert = require('./stockAlert');
const virtualTryOn = require('./virtualTryOn');
const whatsapp = require('./whatsapp');
const wishlist = require('./wishlist');

/**
 * Initialize all GA4 event dispatchers
 */
function init() {
  // Push page_view always as the first one
  page.pushPageView();

  // Subscriptions
  accessibility.subscribeToAnalyticsEvents();
  account.subscribeToAnalyticsEvents();
  atc.subscribeToAnalyticsEvents();
  cart.subscribeToAnalyticsEvents();
  chat.subscribeToAnalyticsEvents();
  checkout.subscribeToAnalyticsEvents();
  contact.subscribeToAnalyticsEvents();
  dispatcher.subscribeToAnalyticsEvents();
  faqs.subscribeToAnalyticsEvents();
  landing.subscribeToAnalyticsEvents();
  login.subscribeToAnalyticsEvents();
  menu.subscribeToAnalyticsEvents();
  modal.subscribeToAnalyticsEvents();
  newsletter.subscribeToAnalyticsEvents();
  page.subscribeToAnalyticsEvents();
  pageDesigner.subscribeToAnalyticsEvents();
  pdp.subscribeToAnalyticsEvents();
  plp.subscribeToAnalyticsEvents();
  productCustomizer.subscribeToAnalyticsEvents();
  productTile.subscribeToAnalyticsEvents();
  search.subscribeToAnalyticsEvents();
  stockAlert.subscribeToAnalyticsEvents();
  virtualTryOn.subscribeToAnalyticsEvents();
  whatsapp.subscribeToAnalyticsEvents();
  wishlist.subscribeToAnalyticsEvents();
}

module.exports = {
  init,
};
